import ReactMarkdown from "react-markdown";
import { SpecialComponents } from "react-markdown/lib/ast-to-react";
import { NormalComponents } from "react-markdown/lib/complex-types";
import rehypeRaw from "rehype-raw";
interface Props {
	children: string;
	className?: string;
	contentClick?: (url: string) => void;
	extra?: Partial<Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents> | undefined;
}

export default function MarkdownContent({ children, className, contentClick, extra }: Props) {
	return (
		<ReactMarkdown
			components={{
				h1: ({ node, ...props }) => <h1 {...props} className="text-2xl font-semibold text-left mb-2" />,
				h2: ({ node, ...props }) => <h2 {...props} className="text-base font-semibold text-left mb-4" />,
				p: ({ node, ...props }) => <p {...props} className="text-left font-normal mb-7 leading-6" />,

				ol: ({ node, ordered, ...props }) => <ol {...props} className="mb-5" />,
				ul: ({ node, ...props }) => <ul {...props} className="mb-5" />,
				li: ({ node, ordered, ...props }) => {
					const _props = { ...props, ordered: String(ordered) };
					return <li {..._props} className="mb-2 list-decimal list-inside" />;
				},
				a: ({ node, ...props }) => (
					<a
						{...props}
						className="link-text underline underline-offset-4"
						onClick={(e) => {
							e.preventDefault();
							contentClick && contentClick(props?.href || "");
						}}
					/>
				),
				...extra,
			}}
			rehypePlugins={[rehypeRaw] as any}
			className={className}
		>
			{children}
		</ReactMarkdown>
	);
}
